// extracted by mini-css-extract-plugin
module.exports = {"TextInput":"TextInput_TextInput__56TUD"};